import React from 'react';
import SkeletonButton from '../Button/SkeletonButton';
import TwitterIcon from '@material-ui/icons/Twitter';
import T from 'i18n-react';
import { darken } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { TWITTER_BASE } from '../styles/variables';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: TWITTER_BASE,
    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: darken(TWITTER_BASE, 0.1),
    },
  },
}));

export const createPlanPageShareText = (
  title: string,
  planPageUrl: string,
  prefecture?: string,
): string => {
  const hashtagOtetsubito = T.translate('twitter.hashtagOtetsubito');
  const hashtagOtetsutabi = T.translate('twitter.hashtagOtetsutabi');
  const hashTagPrefecture = prefecture ? ` #${prefecture}` : '';

  return `${title}\n\n${hashtagOtetsubito} ${hashtagOtetsutabi}${hashTagPrefecture}\n${planPageUrl}`;
};
export const createBusinessPageShareText = (
  name: string,
  businessPageUrl: string,
  prefecture?: string,
): string => {
  const startOtetsutabi = T.translate('twitter.startOtetsutabi');
  const hashtagOtetsutabi = T.translate('twitter.hashtagOtetsutabi');
  const followMe = T.translate('twitter.followMe');
  const hashTagPrefecture = prefecture ? ` #${prefecture}` : '';
  return `${name}\n${startOtetsutabi}\n${followMe}\n\n${hashtagOtetsutabi}${hashTagPrefecture}\n${businessPageUrl}`;
};

type TwitterButtonProps = {
  loaded?: boolean;
  text: string;
  tweetUrl?: string;
  hashtags?: string;
};

// Refer to https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/overview
const TwitterButton = ({
  loaded,
  text,
  tweetUrl = 'https://twitter.com/intent/tweet',
  hashtags,
}: TwitterButtonProps) => {
  const classes = useStyles();

  let href = `${tweetUrl}?text=${encodeURIComponent(
    text + (hashtags ? '\n' : ''),
  )}`;

  if (hashtags) href += `&hashtags=${hashtags}`;

  return (
    <SkeletonButton
      loaded={loaded}
      startIcon={<TwitterIcon />}
      color="primary"
      variant="contained"
      target="_blank"
      rel="noopener"
      className={clsx('twitter-share-button', classes.root)}
      href={href}
      data-show-count={false}
    >
      {T.translate('tweet')}
    </SkeletonButton>
  );
};

export default TwitterButton;
